var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-radius":"24px","padding":"16px","background-color":"#0d3d3d","color":"white","margin-top":"32px","text-align":"center","font-size":"18px"},on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }